import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "../login/forms.scss";
import * as PR from "../../prime-modules/index";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Login from "../login/Login";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/auth";
import Signup from "../login/Signup";
import ForgotPassword from "../ForgotPassword";
import SelectLanguageDropDown from "./LanguageDropDown";
import ResetPassword from "../ResetPassword";
import VerifyEmail from "../VerifyEmail";
import { esimIccidActions } from "../../store/esim";
import { affiliateTrackingInfoActions } from "../../store/affiliateTracking";
import { cartFilterActions } from "../../store/cart";
import { stateActions } from "../../store/stateKey";
import { envConfig, } from "../../constants";
import { googleLogin } from "../../services/api";
import PageLoading from "./PageLoading";
import getAssets from '../../assets/data/brandingAssets.json';
import { getAllCountries } from "../../genericFunctions/GetAllCountries";
import { paymentActions } from "../../store/payment";
import { useToast } from "../../context/ToastContext";
import { useTranslation } from "react-i18next";

const HeaderMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const queryParams = new URLSearchParams(useLocation().search);
  const afid = queryParams.get("afid");
  const { showToast, labels, general, isBase64Image, header, redeemVoucher } = useToast();
  const pathname = window.location.pathname?.toLowerCase();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const { search } = useLocation();
  const getCode = new URLSearchParams(search).get("code");
  const state = new URLSearchParams(search).get("state");
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  const userData = useSelector(state => state.auth.sessionData);
  let username = userData?.firstName + " " + userData?.lastName;
  if (username.length > 12) {
    username = username.slice(0, 10) + '...'
  }
  const cartData = useSelector((state) => state.cart.catalogCart);
  const idPath = useSelector(state => state.auth.idPath)
  const [visible, setVisible] = useState(false);
  const [formState, setFormState] = useState("");
  const accountRef = useRef(null);
  const stateKey = useSelector(state => state.stateKey.stateKey);
  const affiliateTrackingData = useSelector(state => state.affiliateTracking.affiliateTrackingInfo);
  const [loading, setLoading] = useState(false);
  const [troubleSigninVisible, setTroubleSigninVisible] = useState(false);
  const headers = useMemo(() => {
    return { afid: affiliateTrackingData };
  }, [affiliateTrackingData]);
  useEffect(() => {
    const currentVersion = process.env.REACT_APP_VERSION;
    const cachedVersion = localStorage.getItem('appVersion');
    if (!cachedVersion || (cachedVersion !== currentVersion)) {
      // Clear outdated cache and update to the new version
      localStorage.setItem('appVersion', currentVersion);
      // Avoid infinite reloads
      if (cachedVersion) {
        window.location.reload(true);
      }
    }
  }, []);
  const logoutHandler = () => {
    dispatch(authActions.onLogout());
    dispatch(esimIccidActions.deleteAllStoredEsims())
    dispatch(esimIccidActions.deleteEsim());
    dispatch(affiliateTrackingInfoActions.deleteAffiliateTrackingInfo());
    dispatch(cartFilterActions.removeRandomIdInPayment());
    dispatch(paymentActions.removePaymentResponse());
    const getCartObj = { ...cartData };
    delete getCartObj.discountedPercentage;
    delete getCartObj.discountedPrice;
    delete getCartObj.dataAmountForDisplay;
    delete getCartObj.promoCodePrice;
    delete getCartObj.promoCode;
    dispatch(cartFilterActions.setCatalogCart(getCartObj))
    navigate('/');
  }
  const accountMenu = [
    {
      icon: "pi pi-user",
      label: labels.LBL0080,
      command: () => navigate("/my-account")
    },
    {
      icon: "pi pi-power-off",
      label: labels.LBL0081,
      command: logoutHandler
    }
  ]
  const  isJsonString = (str)  => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  const navigatePath = (selectedPath) => {
    pathname !== selectedPath && navigate(selectedPath)
  }
  const order = isJsonString(header.HEAD0001) ? JSON.parse(header.HEAD0001): [];
  const configMenus = [
    {
      id: 'home',
      lableId: "MENU001",
      label:header.MENU001,
      className: (pathname === '/') ? 'p-menuitem-active' : '',
      command: () => navigatePath('/')
    },
    {
      id: 'faq',
      label: header.MENU007,
      lableId: "MENU007",
      className: (pathname === '/faq') ? 'p-menuitem-active' : '',
      command: () => navigatePath('/faq'),
      visible: (getAssets.partners.display),
    },
    {
      id: 'aboutUs',
      label: header.MENU005,
      lableId: "MENU005",
      className: (pathname === '/about-us') ? 'p-menuitem-active' : '',
      command: () => navigatePath('/about-us')
    },
    {
      id: 'contact',
      label: header.MENU006,
      lableId: "MENU006",
      className: (pathname === '/contact') ? 'p-menuitem-active menu-item-contact' : 'menu-item-contact',
      command: () => navigatePath('/contact')
    }
  ].sort((a, b) => order.indexOf(a.lableId) - order.indexOf(b.lableId)).filter(m => m.lableId ?( order.length ? order.includes(m.lableId) : true) : true);

  const menuItems = [
    ...configMenus,
    {
      id: 'pricing',
      label: labels.LBL0066,
      visible: (screenWidth < 960),
      className: (pathname === '/pricing') ?  'p-menuitem-active menu-item-pricing' : 'active menu-item-pricing',
      command: () => navigatePath('/pricing')
    },
    {
      id: 'redeemVoucher',
      label: redeemVoucher.VOUC001,
      visible: (screenWidth < 960),
      className: (pathname === '/redeem-voucher') ? 'p-menuitem-active menu-item-contact' : 'menu-item-contact',
      command: () => navigatePath('/redeem-voucher')
    },
    {
      id: 'login',
      label: labels.LBL0067,
      visible: (!isLoggedIn && screenWidth < 960),
      command: () => { renderFormState(true, 'login') }
    },
    {
      id: 'signup',
      label: labels.LBL0038,
      visible: (!isLoggedIn && screenWidth < 960),
      command: () => { renderFormState(true, 'signup') }
    },
    {
      id: 'myAccount',
      label: labels.LBL0080 + " (" + username + ")",
      visible: (isLoggedIn && screenWidth < 960),
      command: () => navigate("/my-account"),
      className: 'username'
    },
    {
      id: 'logout',
      label: labels.LBL0081,
      visible: (isLoggedIn && screenWidth < 960),
      command: logoutHandler
    }
  ];

  useEffect(() => {
    if (afid) {
      navigate("/");
      dispatch(affiliateTrackingInfoActions.setAffiliateTrackingInfo(afid));
    }
  }, [afid, dispatch, navigate]);

  const renderFormState = useCallback((state, formName) => {
    setVisible(state);
    setFormState(formName);
  }, [])

  useEffect(() => {
    if (getCode && state) {
      setLoading(true);
      if (state === stateKey) {
        const loginDetails = (response) => {
          dispatch(stateActions.removeStateKey());
          if (response.result === "SUCCESS") {
            const callingCode = response.data.phone?.callingCode ? response.data.phone?.callingCode : '';
            getAllCountries(showToast, dispatch, callingCode, '');
            dispatch(authActions.onLogin(response.data));
            dispatch(esimIccidActions.deleteEsim());
            renderFormState(false, "")
            navigate('/');
            setLoading(false);
          } else if (response.result === "FAILED") {
            const error = response.error;
            showToast(error.severity, error.errorMsg);
            setTimeout(() => {
              navigate('/')
            }, [2000])
            setLoading(false);
          } else {
            setLoading(false);
          }
        }
        googleLogin(getCode, headers, dispatch, loginDetails)
      } else if (stateKey) {
        dispatch(stateActions.removeStateKey())
        showToast('error', 'USRLGN-06'); // validation.invalidSignin
        setLoading(false);
      } else {
        setLoading(false);
      }
    } else {
      const countryCode = envConfig.REACT_APP_DEFAULT_PHONE_COUNTRY.toUpperCase();
      getAllCountries(showToast, dispatch, '', countryCode);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCode, dispatch, state, headers, navigate, renderFormState, stateKey])

  useEffect(() => {
    if(location.hash.includes("#login")) {
      navigate(location.pathname + location?.search)
      !isLoggedIn && renderFormState(true, "login");
    }
  }, [location?.hash, location.pathname, location?.search, navigate, renderFormState, isLoggedIn])

  const start = (
    <Link to="/"><PR.Image className="logo" src={isBase64Image(general.GEN0002) ? `data:image/png;base64,${general.GEN0002}` : getAssets.logo.logo_dark} alt="Logo" width="150"/></Link>
  );
  const end = () => {
    return (
      <div className="flex">
         {(screenWidth > 960) && (
          <PR.Button label={labels.LBL0066} onClick={() => { navigatePath('/pricing') }} className="p-button pricing-btn" />
         )}
        <SelectLanguageDropDown />
        {(screenWidth > 960) && (
        <PR.Button label={redeemVoucher.VOUC001} className="p-button login-btn" onClick={() => { navigatePath('/redeem-voucher') }} />
         )}
        {(screenWidth > 960) && (
          isLoggedIn
            ? <div className="flex align-items-center">
              <div>
                <PR.Menu model={accountMenu} ref={accountRef} popup id="account_menu" className="account-menu-dropdown" />
                <PR.Button icon="pi pi-user" onClick={(event) => accountRef.current.toggle(event)} aria-controls="account_menu" aria-haspopup className="user-button p-button-rounded" />
              </div>
              {userData.firstName &&
                <b>{userData.firstName + " " + userData.lastName}</b>
              }
            </div>
            : <>
              <PR.Button label={labels.LBL0067} onClick={() => { renderFormState(true, 'login') }} className="p-button login-btn" />
              <PR.Button label={labels.LBL0038} onClick={() => { renderFormState(true, 'signup') }} />
            </>)
        }
      </div>
    )
  }

  useEffect(() => {
    if (idPath.pathName === 'reset-password') {
      renderFormState(true, "resetPwd")
    } else if (idPath.pathName === 'verify-email' || idPath.pathName === "update-email") {
      renderFormState(true, "verifyEmail")
    }
  }, [idPath.pathName, isLoggedIn, renderFormState])

  // Sticky Header ====

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  });
  const isSticky = () => {
    const header = document.querySelector('.header');
    if (!header) {
      console.error("Header element not found.");
      return;
  }
    const scrollTop = window.scrollY;
    scrollTop >= 1 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
  };

  useEffect(() => {
    const handleWindowResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });

  useEffect(() => {
    const checkHash = () => {
      const { pathname, hash } = window.location;
      if (pathname === "/" && hash === "#trouble-signin") {
        setTroubleSigninVisible(true);
        window.history.replaceState(null, "", window.location.pathname);
      }
    };
    checkHash();
    window.addEventListener("hashchange", checkHash);
    return () => window.removeEventListener("hashchange", checkHash);
  }, []);

  const handleContinue = () => {
    setTroubleSigninVisible(false);
    renderFormState(true, 'login')
  };

  return (
    <>
      <div className={`header-navigation lang-${i18n.language}`}>
        <PR.Menubar model={menuItems} start={start} end={end} />
      </div>
      <PR.Dialog visible={visible} draggable={false} blockScroll={true} onHide={() => { renderFormState(false, ""); dispatch(authActions.deleteStoreIdPath()) }} className="forms-dialog" resizable={false}>
        <div className="grid grid-nogutter header-text">
          <div className="col-12 lg:col-12 md:col-12">
            {formState === 'login'
              ? <Login renderFormState={renderFormState} />
              : formState === 'signup'
                ? <Signup renderFormState={renderFormState} />
                : formState === 'forgotpwd'
                  ? <ForgotPassword renderFormState={renderFormState} />
                  : formState === 'resetPwd'
                    ? <ResetPassword renderFormState={renderFormState} />
                    : formState === 'verifyEmail'
                      ? <VerifyEmail renderFormState={renderFormState} />
                      : <></>
            }
          </div>
        </div>
      </PR.Dialog>
      {
        loading && <PageLoading />
      }
      <PR.Dialog visible={troubleSigninVisible} onHide={() => setTroubleSigninVisible(false)}
      className="forms-dialog t-signingin-dialog" draggable={false} resizable={false} blockScroll={true}
      maskClassName="t-signingin-mask" >
        <div className="form-section">
          <div className="form">
            <h3>{labels?.LBL0176 || "Trouble Signing in?"}</h3>
            <p className="signing-p">{labels?.LBL0177 || "Your account was switched to Google or Apple login because you used one of them before. You can't use a username and password anymore—just sign in with your Google or Apple account linked to your email."}</p>
            <PR.Button
            label={labels?.LBL0178 || "Continue"}
            type="submit"
            className="login-btn"
            onClick={handleContinue}
            />
          </div>
        </div>
      </PR.Dialog>
    </>
  );
}
export default HeaderMenu